import {MediaFilter} from './media-filter';

export class MediaListRequest {
  filter: MediaFilter;
  search: string;
  limit: number;
  offset: number;
  sortProp: string;
  sortDir: string;


  constructor(filter: MediaFilter, search: string, limit: number, offset: number, sortProp: string, sortDir: string) {
    this.search = search;
    this.limit = limit;
    this.offset = offset;
    this.sortProp = sortProp;
    this.sortDir = sortDir;
    this.filter = filter;
  }
}
